
// // 注册jsbridge
// function connectWebViewJavascriptBridge (callback) {
//   if (isAndroid) {
//     if (window.WebViewJavascriptBridge) {
//       callback(WebViewJavascriptBridge)
//     } else {
//       document.addEventListener(
//         'WebViewJavascriptBridgeReady',
//         function () {
//           callback(WebViewJavascriptBridge)
//         },
//         false
//       );
//     }
//     return;
//   }
//   if (isiOS) {
//     if (window.WebViewJavascriptBridge) {
//       return callback(WebViewJavascriptBridge);
//     }
//     if (window.WVJBCallbacks) {
//       return window.WVJBCallbacks.push(callback);
//     }
//     window.WVJBCallbacks = [callback];
//     var WVJBIframe = document.createElement('iframe');
//     WVJBIframe.style.display = 'none';
//     WVJBIframe.src = 'https://__bridge_loaded__';
//     document.documentElement.appendChild(WVJBIframe);
//     setTimeout(function () {
//       document.documentElement.removeChild(WVJBIframe)
//     }, 0)
//   }
// }
// // 调用注册方法
// connectWebViewJavascriptBridge(function (bridge) {
//   if (isAndroid) {
//     console.log(3214)
//     bridge.init(function (message, responseCallback) {
//       responseCallback(data);
//     });
//   }
//   console.log(321)
//   if (isiOS) {
//     bridge.registerHandler('testFunction', function (data, responseCallback) {
//       responseCallback(responseData)
//     })
//   }

// });

var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

function setupWebViewJavascriptBridge (callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge)
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }
  window.WVJBCallbacks = [callback]
  let WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'https://__bridge_loaded__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(() => {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

export default {
  callhandler (name, data, callback) {

    if (isiOS) {
      setupWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler(name, data, callback)
      })
      return;
    }
    if (isAndroid) {
      try {
        var calData = window.Mobile[name](data)
        // var da = calData(data)
        // console.log('da', da)
        callback && callback(calData)
      } catch (e) {
        callback && callback(false)
        console.log('e1', e.message)
      }
      return
    }
  },
  registerhandler (name, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler(name, function (data, responseCallback) {
        callback(data, responseCallback)
      })
    })
  }
}

// data是原生返回的值
//  //注册js方法供OC调用
// init(){
//  this.$bridge.registerhandler('showAlert', (data, responseCallback) => {
//     this.operatorId = data;//接收原生回传过来的值
//     responseCallback("https://www.baidu.com")//把值返回给原生
//   })
// }
// 此方法需要在mounted方法中挂载，OC才能访问到
//  mounted() {
//     //客户端方法的组件中
//     this.init()

//   }


// WEBPACK FOOTER //
// ./src/common/bridge.js